import { useEffect, useState } from 'react'

export default function Home() {
    const [currentSkill, setCurrentSkill] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSkill((prev) => (prev + 1) % skills.length);
        }, 2000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className='relative w-full h-screen flex flex-col items-center justify-center animate-fade-in-down'>
            <div
                className="absolute inset-0 bg-cover bg-center -z-10"
                style={{ backgroundImage: `url('assets/hero.png')` }}
            ></div>
            <div className="absolute inset-0 bg-white/70 -z-10"></div>
            <div className="absolute inset-0 -z-10 pointer-events-none"
                style={{
                    background: "linear-gradient(to bottom, rgba(255,255,255,0) 70%, rgba(255,255,255,1) 100%)",
                }}
            ></div>

            <div className="absolute inset-0 -z-10 overflow-hidden">
                {[...Array(20)].map((_, i) => (
                    <div
                        key={i}
                        className="absolute w-2 h-2 bg-white/50 rounded-full animate-float"
                        style={{
                            left: `${Math.random() * 100}%`,
                            top: `${Math.random() * 100}%`,
                            animationDelay: `${Math.random() * 5}s`,
                            animationDuration: `${5 + Math.random() * 5}s`,
                        }}
                    />
                ))}
            </div>

            <div className='flex flex-col items-center justify-center gap-8'>
                <div className='flex flex-col items-center '>
                    <h1 className='text-5xl font-bold text-customPurple max-sm:text-2xl max-[400px]:text-lg'>Hi, I'm</h1>
                    <p className='text-7xl font-bold bg-gradient-to-r from-lightPurple to-mainPinkColor bg-clip-text text-transparent max-sm:text-4xl '>Samira Kamilova</p>
                    <p className='text-2xl text-darkPurple max-sm:text-sm'>Junior software developer</p>
                </div>
                <div className="h-12 flex items-center justify-center mb-8 text-center">
                    <p className="text-xl md:text-2xl text-darkPurple font-semibold">
                        Specializing in{" "}
                        <span className="inline-block min-w-[200px] bg-gradient-to-r from-lightPurple to-mainPinkColor bg-clip-text text-transparent max-sm:text-4xl animate-pulse">
                            {skills[currentSkill].name}
                        </span>
                    </p>
                </div>
                <button
                    className='bg-gradient-to-r from-lightPurple to-mainPinkColor rounded-full px-4 py-2 font-semibold text-white flex flex-row gap-2 transition-all duration-200 hover:brightness-75 border-0 '>
                    <a href='/assets/CV.pdf' target='_blank' rel="noopener noreferrer">Resume</a>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                    </svg>
                </button>
            </div>
        </div>
    )
}


const skills = [
    { name: "React", level: 85 },
    { name: "JavaScript", level: 80 },
    { name: "HTML/CSS", level: 90 },
    { name: "Tailwind CSS", level: 85 },

    { name: ".NET", level: 75 },
    { name: "C#", level: 70 },
    { name: "SQL", level: 65 },

    { name: "Git", level: 80 },
    { name: "Responsive Design", level: 85 },
];